import React from 'react';
import Desktop from './components/Desktop';

const App = () => {
  return <Desktop />;
};

export default App;
